import React from 'react';
import '../styles/Error.css'; // Assuming you have a CSS file for styling the error page

const Error = () => {
  return (
    <div className="error-container">
      <h1 className="error-heading">Oops! Something went wrong.</h1>
      <p className="error-description">
        We encountered an error while processing your request. Please try again later.
      </p>
    </div>
  );
};

export default Error;
